/**
 * response
 */
import { Message } from 'element-ui'
import i18n from '../../../../i18n'
import router from '../../../../router'
import store from '../../../../store'
import ERR_CONFIG from '@/config/responseError'
import { setCookie, operateLog } from '@/utils/tool'

const TOKEN_BAD = [-3, -105, ERR_CONFIG.TOKEN_NOT_ACCEPTABLE]
const reLogin = () => {
    // 登录失效
    // 清除用户信息
    operateLog('登录失效')
    store.commit('user/clearUserInfo')
    setCookie('S2', '', -1)
    // 弹框
    Message.closeAll()
    Message({
      type: 'warning',
      message: i18n.t('cc_sys_account_logout'),
      onClose: () => {
        router.push({ path: '/user/login' })
      }
    })
}
export default [
  (response) => {
    // let data = response.data.data ? response.data.data : response.data
    let errno = response.data.errno
    if (errno > 0) {
      // Message.error(i18n.t('cc_msg_network_busy'));
      return Promise.reject(response.data)
    } else if (TOKEN_BAD.includes(+errno)) {
      reLogin()
      return Promise.reject(response.data)
    }
    return response.data
    // if (response && response.config) {
    //   // 需要修改，清除loading

    // }
    // if (response.data.errno < 0) {
    //   // 统一抛出错误
    //   Message({
    //     message: response.data.msg,
    //     type: 'error',
    //     duration: 3000
    //   })
    // }
  },
  (error) => {
    if (error && error.config) {
      // 需要修改，清除loading
    }

    let err = {
      // status: error.response && error.response.status,
      // errcode: '',
      // message:
      //   (error.response &&
      //     error.response.data &&
      //     error.response.data.message) ||
      //   error.message ||
      //   '未知错误',
      // stack: error.stack || ''
    }
    // if (error.response && error.response.status == 406) {
    //   Message.error(i18n.t('cc_msg_network_busy'));
    // }

    if (error && error.config) {
      // let errorMessage
      // if (err.message.indexOf('timeout') !== -1) {
      //   errorMessage = '当前访问请求过多，请稍候再试'
      // } else if (error.message === 'Network Error') {
      //   if (navigator.onLine) {
      //     errorMessage = `当前服务器不可用(code:${error.response.status})，请联系客服 021-61515590`
      //   } else {
      //     errorMessage = '当前网络不可用，请检查你的网络或稍候再试'
      //   }
      // }
      // if (errorMessage) {
      //   // 需要修改，弹出错误提示
      // }
    }

    // if (error.response && error.response.data) {
    //   err.errno = error.response.data.errno
    //   err.message = error.response.data.message
    // }
    let response = error.response
    // 当前baseUrl没有匹配，可能是apiList更新，所以返回首页
    if (response && response.status == 404 && !response.config.baseURL) {
      console.error('api not found', response)
      // 清除用户信息
      store.commit('user/clearUserInfo')
    } else if (response) {
      let errcode = response.headers['x-is-error-code'] || response.data.errno
      err.errno = errcode
      err.data = response.data.data || undefined
      // if (errcode == ERR_CONFIG.NO_PERMISSION_OPERATION) {  // 无权限
      //   Message.error(i18n.t('err_nopermit'))
      // }
      if (TOKEN_BAD.includes(+errcode)) {
        reLogin()
        return Promise.reject(err)
      }
    }
    return Promise.reject(err)
  }
]
